import { Button, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react'
import { FC, useEffect, useRef } from 'react'
import useHomeGradeStore from '../../store/home/useHomeGradeStore'
import { useSchoolStore } from '../../store/school/useSchoolStore'
import { useGroupStore } from '../../store/group/useGroupStore'
import { CustomDatePicker } from '../common/Input'
import { BaseDivider, BaseModal, BaseModalHeader } from '../common/Modal'
import { ModalText } from '../common/Text'
import { SelectArrivalTanks } from './SelectArrivalTanks'
import { SelectDepatureTank } from './SelectDepartureTank'
import { SelectTanksContinue } from './SelectTanksContinue'

export interface SelectTanksGradeProps {
  isOpen: boolean
  onOpen: () => void
  onOpenChange: () => void
}

export const SelectTanksGrade: FC<SelectTanksGradeProps> = ({ isOpen, onOpenChange, onOpen }) => {
  const {
    setArrTanksValues,
    selectedDepTanks,
    selectedArrTanks,
    gradeDate,
    setGradeDate,
    gradeDateBorderColor,
  } = useHomeGradeStore()

  const getTankRelationsMap = useGroupStore((state) => state.getTankRelationsMap)
  const tankRelations = getTankRelationsMap()
  const schools = useSchoolStore((state) => state.schools)

  // Use refs to always access the latest values inside useEffect
  const tankRelationsRef = useRef(tankRelations)
  const schoolsRef = useRef(schools)
  const setArrTanksValuesRef = useRef(setArrTanksValues)

  // Keep refs updated with latest values
  useEffect(() => {
    tankRelationsRef.current = tankRelations
    schoolsRef.current = schools
    setArrTanksValuesRef.current = setArrTanksValues
  })

  useEffect(() => {
    if (gradeDate !== null && selectedArrTanks.length !== 0 && selectedDepTanks.length !== 0) {
      setArrTanksValuesRef.current(tankRelationsRef.current, schoolsRef.current)
    }
  }, [gradeDate, selectedArrTanks, selectedDepTanks])

  return (
    <BaseModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size={'3xl'}
      isDismissable={true}
      data-testid="select-tanks-grade-modal"
      classNames={{
        wrapper: 'z-[1400]',
        backdrop: 'z-[1300]',
      }}
    >
      <ModalContent className="overflow-x-hidden">
        {(onClose) => (
          <>
            <BaseModalHeader title="Grade" description={ModalText('Grade')} />
            <ModalBody className="gap-1 min-h-[20rem] sm:min-h-[8rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden overflow-y-auto">
              <BaseDivider />
              <SelectDepatureTank schoolIdList={tankRelations} storedSchoolList={schools} />
              <SelectArrivalTanks />
              <CustomDatePicker
                label="Grading Date"
                value={gradeDate}
                setValue={setGradeDate}
                dateBorderColor={gradeDateBorderColor}
                warnText="Please enter a Grading Date."
              />
            </ModalBody>
            <ModalFooter className="pb-6 sm:pb-8 pl-6 sm:pl-10 pr-6 sm:pr-10">
              <div className="flex gap-3 justify-end w-full">
                <Button
                  variant="light"
                  className="font-bold text-tdplindigo border border-tdplindigo"
                  onPress={onClose}
                >
                  Cancel
                </Button>
                <SelectTanksContinue onClose={onClose} onOpen={onOpen} />
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </BaseModal>
  )
}
